import {ApiService} from "./api"; // Assuming ApiService is correctly set up
import {StatEventType} from "../models/StatEvent"; // Assuming you create this enum/type

// Define the payload structure expected by the backend /stats/log endpoint
interface LogEventPayload {
    eventType: StatEventType;
    templateId?: string;
    templateName?: string;
    designKey?: string;
    designName?: string;
    generationId?: string; // Optional: To link generation events
    errorMessage?: string
    durationMs?: number
    // Add other relevant fields as needed, matching LogEventBody in backend
}

class StatsLogger {
    private apiService: ApiService;

    constructor(apiServiceInstance: ApiService) {
        this.apiService = apiServiceInstance;
    }

    logEvent = (payload: LogEventPayload): void => {
        // Fire-and-forget: Send the log event to the backend endpoint.
        // No need to wait for the response unless you want confirmation.
        this.apiService.api.post('/stats/log', payload)
            .then(() => {
                // Optional: Log success locally for debugging
                // console.log('Stats event logged:', payload.eventType);
            })
            .catch(error => {
                // Log errors locally, but don't block user flow
                console.error('Failed to log stats event:', payload.eventType, error);
            });
    };

    // --- Specific Helper Methods ---

    logGenerationStart = (templateId: string, templateName: string, designKey: string, designName: string, generationId: string): void => {
        this.logEvent({
            eventType: StatEventType.IMAGE_GENERATION_STARTED,
            templateId,
            templateName,
            designKey,
            designName,
            generationId,
        });
    };

    logDownload = (templateId: string, templateName: string, designKey: string, designName: string, generationId?: string): void => {
        this.logEvent({
            eventType: StatEventType.IMAGE_DOWNLOADED,
            templateId,
            templateName,
            designKey,
            designName,
            generationId,
        });
    };

    logShare = (templateId: string, templateName: string, designKey: string, designName: string, generationId?: string): void => {
        this.logEvent({
            eventType: StatEventType.IMAGE_SHARED,
            templateId,
            templateName,
            designKey,
            designName,
            generationId,
        });
    };

}

// Export a singleton instance potentially (depends on how ApiService is managed)
// This requires ApiService to be available globally or via context easily.
// Example (adjust based on your ApiService setup):
// import { getApiServiceInstance } from './apiServiceInstance'; // Hypothetical function
// export const statsLogger = new StatsLogger(getApiServiceInstance());

// Alternatively, manage it via React Context if ApiService is in context.
export default StatsLogger;

